var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import { SingleConcurrentRequestController, safeReaction } from '../../common';
const CUSTOMER_ROLES_PATH = '/mandate/menu-item-roles';
export default class ProfileTypeStore {
    constructor(rootStore, initialProfileTypes) {
        Object.defineProperty(this, "profileTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "provided", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SingleConcurrentRequestController()
        });
        Object.defineProperty(this, "fetchJson", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url) => {
                try {
                    return await this.controller.get(url, { withCredentials: true });
                }
                catch (error) {
                }
                return null;
            }
        });
        Object.defineProperty(this, "updateProfileTypes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                if (this.provided) {
                    return;
                }
                const { customer, isDealer } = this.rootStore.ssoStore.authData;
                const { URLData } = this.rootStore.environmentStore;
                let response = [];
                if (customer || isDealer) {
                    response = (await this.fetchJson(URLData.commonAPIBaseURL.concat(CUSTOMER_ROLES_PATH))) || [];
                }
                response.push('all');
                this.setProfileTypes(response, false);
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        if (initialProfileTypes) {
            this.setProfileTypes(initialProfileTypes, true);
        }
        else if (!rootStore.propStateStore.isSsr) {
            this.updateProfileTypes();
            safeReaction(rootStore, () => { var _a; return `${(_a = this.rootStore.ssoStore.authData.customer) === null || _a === void 0 ? void 0 : _a.customerId}${this.rootStore.ssoStore.authData.isDealer}`; }, () => this.updateProfileTypes());
        }
    }
    setProfileTypes(profileTypes, provided = this.provided) {
        this.provided = provided;
        this.profileTypes = profileTypes;
    }
}
__decorate([
    observable
], ProfileTypeStore.prototype, "profileTypes", void 0);
__decorate([
    observable
], ProfileTypeStore.prototype, "provided", void 0);
__decorate([
    action
], ProfileTypeStore.prototype, "setProfileTypes", null);
//# sourceMappingURL=ProfileTypeStore.js.map